import React from "react"

function IconLink({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="link"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-link"
      {...props}
    >
      <path
        d="M9.954 6.709a.655.655 0 0 1 .106 1.3l-.106.009H7.663a4.008 4.008 0 0 0-.213 8.011l.213.006h2.29a.655.655 0 0 1 .107 1.3l-.106.01H7.663a5.317 5.317 0 0 1-.237-10.63l.237-.006h2.29zm6.267 0a5.318 5.318 0 0 1 .236 10.63l-.236.005H13.93a.655.655 0 0 1-.107-1.3l.107-.009h2.29a4.009 4.009 0 0 0 .213-8.011l-.212-.006H13.93a.655.655 0 0 1-.107-1.3l.107-.01h2.29zm-.534 4.663a.655.655 0 0 1 .106 1.3l-.106.01H8.196a.655.655 0 0 1-.106-1.301l.106-.009h7.491z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconLink
